export interface OptionDropdownSelect {
  value: string;
  name: string;
}

export class OptionDropdown implements OptionDropdownSelect {
  value: string;
  name: string;

  constructor(value: string, name: string) {
    this.value = value,
    this.name = name
  }
}

export interface SelectControl {
  title: string;
  controlName: string;
  options: OptionDropdownSelect[];
  validationMessage: string;
  showOptionalLabel?: boolean;
}